<template>
  <div id="top">
    <div>
      <ContentHeader class="content"/>
    </div>
    <div class="wrapper">
      <section id="maincode">
      </section>
      <section id="whatis">
        <article>
          <h1>{{ $t('contact.title') }}</h1>
          <p> {{ $t('contact.text') }}</p>
          <div v-if="this.$vuetify.breakpoint.lgAndUp">
          <v-dialog v-model="dialog" width="40%">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">Contact</v-btn>
            </template>
            <v-card elevation="20" class="contact-form">
              <br>
              <h2 class="">{{ $t('contact.title') }}</h2>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="firstname"
                        :counter="10"
                        :rules="firstnameRules"
                        label="FirstName"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="lastname"
                        :counter="10"
                        :rules="lastnameRules"
                        label="LastName"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="email_adres"
                        :rules="emailRules"
                        label="E-mail adres"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="subject"
                        :counter="20"
                        :rules="subjectRules"
                        label="Subject"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-textarea v-model="email" label="E-mail" required></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mr-4 mb-5"
                        @click="validate"
                      >Validate</v-btn>
                      <v-btn color="error" class="mr-4 mb-5" @click="reset">Reset Form</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
          </v-dialog>
          </div>
          <div v-else>
          <v-dialog v-model="dialog" class="dialog-phone" width="85%">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on">Contact</v-btn>
            </template>
            <v-card elevation="20" class="contact-form">
              <br>
              <h2 class="">{{ $t('contact.title') }}</h2>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="firstname"
                        :counter="10"
                        :rules="firstnameRules"
                        label="FirstName"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="lastname"
                        :counter="10"
                        :rules="lastnameRules"
                        label="LastName"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="email_adres"
                        :rules="emailRules"
                        label="E-mail adres"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-text-field
                        v-model="subject"
                        :counter="20"
                        :rules="subjectRules"
                        label="Subject"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-textarea v-model="email" label="E-mail" required></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="1"></v-col>
                    <v-col cols="12" md="10">
                      <v-btn
                        :disabled="!valid"
                        color="success"
                        class="mr-4 mb-5"
                        @click="validate"
                      >Validate</v-btn>
                      <v-btn color="error" class="mr-4 mb-5" @click="reset">Reset Form</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card>
          </v-dialog>
          </div>
        </article>
      </section>
      <section id="participate">
        <article>
          <h1>{{ $t('terms.title') }}</h1>
          <p>{{ $t('terms.text') }}</p>
        </article>
      </section>
      <section id="happening">
        <article>
          <h1>{{ $t('buy.title') }}</h1>
          <p>{{ $t('buy.text') }} <a target="_blank" href="https://www.shutterstock.com/g/PascalDeMunck">shutterstock</a>  <a target="_blank" href="https://demuncp.picfair.com">picfair</a></p>
        </article>
      </section>
      <section id="sponsorus">
        <article>
          <h1>{{ $t('thanks.title') }}</h1>
          <p>{{ $t('thanks.text') }} <a target="_blank" href="https://www.facebook.com/yarne.demunck">contact</a></p>
        </article>
      </section>
    </div>
    <div class="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
import axios from 'axios'
export default {
  name: "ViewSpecies",
  data: () => ({
    valid: true,
    dialog: false,
    firstname: "",
    lastname: "",
    firstnameRules: [
      v => !!v || "FirstName is required",
      v => (v && v.length <= 10) || "FirstName must be less than 10 characters"
    ],
    lastnameRules: [
      v => !!v || "LastName is required",
      v => (v && v.length <= 10) || "LastName must be less than 10 characters"
    ],
    email_adres: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    subject: "",
    subjectRules: [
      v => !!v || "Subject is required",
      v => (v && v.length <= 20) || "Subject must be less than 20 characters"
    ],
    email: ""
  }),
  components: {
    ContentHeader,
    Footer
  },
  methods: {
    validate() {
      this.dialog = false
      this.$refs.form.validate();
      var postData = {
        subject: this.subject,
        message: this.email,
        adres: this.email_adres,
        firstname: this.firstname,
        lastname: this.lastname
      }

      axios.post('https://pascaldemunckbackend.com/api/mail/1/send/', postData)
      .then(res => console.log(res.data))
      .catch(err => console.log(err.response))
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss" scoped>
$color-alpha: #ffffff;
$color-beta: #2ecc71;
$color-gamma: #333333;

@mixin cover($i, $url) {
  &:nth-child(#{$i}) {
    &:after {
      background-image: url($url);
    }
  }
}
* {
  border: 0;
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

h1 {
  margin: 0;
  color: black;
  font-size: 240%;
  word-spacing: 4px;
  letter-spacing: 1px;
}
.footer {
  width: 100%;
  margin-top: 80px;
}
.dialog-phone {
  position: relative;
  left: 5%;
}
.content {
  width: 100%;
  height: 3%;
  background-color: black;
  position: absolute;
  top: 0%;
}

.wrapper {
  position: relative;
  top: 108px;
  box-shadow: 0 0 1em $color-gamma;
  section {
    position: relative;
    background: $color-alpha;
    article {
      width: 50%;
      margin: 0 auto;
      padding: 2em 0;
      p {
        margin-bottom: 1em;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
    &:after {
      content: "";
      display: block;
      position: relative;
      background-attachment: fixed;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      height: 30em;
      width: 100%;
    }
    @include cover(1, "../assets/contact_images/contact_bg1.jpg");
    @include cover(2, "../assets/contact_images/contact_bg2.jpg");
    @include cover(
      3,
      "../assets/contact_images/contact_bg3.jpg"
    );
    @include cover(
      4,
      "../assets/contact_images/contact_bg4.jpeg"
    );
    @include cover(
      5,
      "../assets/contact_images/contact_bg4.jpeg"
    );
    @include cover(
      6,
      "../assets/contact_images/contact_bg4.jpeg"
    );
  }
}

@media only screen and (max-width: 600px) {
  .wrapper {
    section {
      article {
        width: 80%;
      }
      &:after {
        height: 15em;
      }
    }
  }
}
</style>